module.exports = __webpack_public_path__ + "static/media/illustration-dino.baf04f00.png";